import React from 'react';
import { StatCounter } from '../shared/StatCounter';
import { Building2, Users, Award, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
export function StatsSection() {
  return <section className="relative py-24 bg-deep-blue overflow-hidden" data-id="element-72">
      {/* Subtle Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-73">
        <div className="absolute top-0 right-0 w-96 h-96 bg-gold rounded-full blur-3xl" data-id="element-74" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8" data-id="element-75">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-76">
          <h2 className="font-heading font-semibold text-4xl md:text-5xl text-white mb-4" data-id="element-77">
            Proven Track Record
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto" data-id="element-78">
            Delivering excellence across Nigeria's construction and engineering
            landscape
          </p>
        </motion.div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-79">
          <StatCounter end={150} suffix="+" label="Projects Completed" icon={<Building2 size={40} strokeWidth={1.5} data-id="element-81" />} data-id="element-80" />
          <StatCounter end={50} suffix="+" label="Corporate Clients" icon={<Users size={40} strokeWidth={1.5} data-id="element-83" />} data-id="element-82" />
          <StatCounter end={3} suffix=" Years" label="Industry Experience" icon={<TrendingUp size={40} strokeWidth={1.5} data-id="element-85" />} data-id="element-84" />
          <StatCounter end={98} suffix="%" label="Client Satisfaction" icon={<Award size={40} strokeWidth={1.5} data-id="element-87" />} data-id="element-86" />
        </div>
      </div>
    </section>;
}